export default "__VITE_ASSET__Kk4QhB6D__"